import React from 'react';
import { Formik } from 'formik';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import Selector from 'react-select';
import { FaSearch } from 'react-icons/fa';
import { MASK_DATE } from '~/constant';
import DateMask from '~/Components/DateMask';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';


export default function FiltrosRelatorio({ onSubmit, isLoading, empreendimentos }) {
  const optionsEmpreendimentos = [
    { value: null, label: 'Todos empreendimentos' },
    ...empreendimentos.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];

  const initialValues = {
    data_inicial: '',
    data_final: '',
    codigo_empreendimento: null,
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {({ values, setFieldValue, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="align-items-end">
                <Col xs="12" sm="4" lg="2">
                  <DateMask
                    initialValue={values.data_inicial}
                    allowEmpty
                    onValidate={value => setFieldValue('data_inicial', value)}
                  >
                    {({ dateError, dateValue, setDate }) => (
                      <Form.Group>
                        <Form.Label>De:</Form.Label>
                        <MaskedInput
                          name="data_inicial"
                          type="tel"
                          guide={false}
                          className={`form-control ${dateError ? 'is-invalid' : ''}`}
                          placeholder="DD/MM/AAAA"
                          mask={MASK_DATE}
                          value={dateValue}
                          onChange={e => setDate(e.target.value)}
                        />
                        {dateError && (
                          <Form.Control.Feedback type="invalid">
                            {dateError}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    )}
                  </DateMask>
                </Col>
                <Col xs="12" sm="4" lg="2">
                  <DateMask
                    initialValue={values.data_final}
                    allowEmpty
                    onValidate={value => setFieldValue('data_final', value)}
                  >
                    {({ dateError, dateValue, setDate }) => (
                      <Form.Group>
                        <Form.Label>Até:</Form.Label>
                        <MaskedInput
                          name="data_final"
                          type="tel"
                          guide={false}
                          className={`form-control ${dateError ? 'is-invalid' : ''}`}
                          placeholder="DD/MM/AAAA"
                          mask={MASK_DATE}
                          value={dateValue}
                          onChange={e => setDate(e.target.value)}
                        />
                        {dateError && (
                          <Form.Control.Feedback type="invalid">
                            {dateError}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    )}
                  </DateMask>
                </Col>
                <Col xs="12" sm="6" lg="4">
                  <Form.Group>
                    <Form.Label>Empreendimento:</Form.Label>
                    <Selector
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      options={optionsEmpreendimentos}
                      isClearable
                      placeholder="Selecione ou deixe em branco para todos..."
                      value={
                        optionsEmpreendimentos.find(
                          opt => opt.value === values.codigo_empreendimento
                        ) || null
                      }
                      onChange={option =>
                        setFieldValue(
                          'codigo_empreendimento',
                          option ? option.value : null
                        )
                      }
                      noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
                    />
                  </Form.Group>
                </Col>
                <Col xs="12" sm="4" lg="2">
                  <Form.Group>
                    <Button
                      type="submit"
                      variant="success"
                      block
                      disabled={isLoading}
                    >
                      <FaSearch /> Buscar
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
}
